import React, { useContext } from 'react';

import { useWindowStore, useAppStore } from '../../stores';
import SiteSeeContext from '../SiteSeeGuides/SiteSeeContext';

const SiteSeeTipTrigger = ( { siteSeeTipId }) => {
  const isMobile = useWindowStore((state) => state.isMobile);
  const settings = useAppStore((state) => state.settings);
  const { platform } = settings || {};
  const {
    siteSeeGuideMode,
    siteSeeGuideId,
    setSiteSeeGuideId,
    setShowSiteSeeGuide,
  } = useContext( SiteSeeContext );

  return platform === 'siteSee'
    && !isMobile
    && siteSeeGuideMode === 'tip'
    && ( siteSeeGuideId !== siteSeeTipId )
    ? (
      <button
        className="siteSeeGuide__tipTrigger"
        type="button"
        onClick={
        () => {
          setSiteSeeGuideId( siteSeeTipId );
          setShowSiteSeeGuide( true );
        }
      }
      >
        ?
      </button>
    )
    : ( <></> );
};

export default SiteSeeTipTrigger;
